import React from 'react';
import styles from './CeldaOrdenable.module.css';

/**
 * Componente reutilizable para celdas de encabezado ordenables
 * @param {string} campo - identificador del campo
 * @param {string} label - texto a mostrar
 * @param {string} ordenPor - campo actual de ordenamiento
 * @param {boolean} ascendente - dirección actual del ordenamiento
 * @param {function} onChange - callback(campo, ascendente) cuando se cambia ordenamiento
 * @param {string} className - clases CSS adicionales para la celda
 * @param {string} title - tooltip al pasar el mouse
 */
const CeldaOrdenable = ({
  campo,
  label,
  ordenPor,
  ascendente,
  onChange,
  className,
  title = 'Click para ordenar',
}) => {
  const esActual = ordenPor === campo;
  const icono = esActual ? (ascendente ? ' ▲' : ' ▼') : '';

  const handleClick = () => {
    if (esActual) {
      // Si ya estamos ordenando por este campo, invertir dirección
      onChange(campo, !ascendente);
    } else {
      // Si cambiamos de campo, comenzar en ascendente
      onChange(campo, true);
    }
  };

  return (
    <td
      className={`${styles.celdaOrdenable} ${className || ''}`}
      onClick={handleClick}
      title={title}
    >
      <strong>
        {label}
        <span className={styles.icono}>{icono}</span>
      </strong>
    </td>
  );
};

export default CeldaOrdenable;
